import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import SignIn from './Components/Auth/SignIn';
import MainDashboard from './Components/Dashbaord/MainDashboard';
import Signup from './Components/Auth/SignUp';
import ProtectedRoutes from './Utils/ProtectedRoutes';
import DashboardLayout from './Utils/MedicaidDasLayout';
import AddMember from './Components/Dashbaord/AddMember';
import AddProvider from './Components/Dashbaord/AddProvider';
import AddType from './Components/Dashbaord/AddType';
import ViewMemberPage from './Components/Dashbaord/ViewMemberPage';
import BillingListing from './Components/Billing/BillingListing';
import MainBillingListing from './Components/Billing/MainBillingListing';
import BillingHistory from './Components/Billing/BillingHistory';
import MemberListing from './Components/Dashbaord/MemberListing';
import ProcessCheque from './Components/Billing/ProcessCheque';
import ChequeDetailsPage from './Components/Billing/ViewChequeDetails';
import ClientList from './Components/Clients/ClientList';
import AddClient from './Components/Clients/AddClient';
import AddCheque from './Components/Cheque/AddCheque';
import ChequeList from './Components/Cheque/ChequeList';
import AddChequeType from './Components/Cheque/AddChequeType';
import NewMemberBillings from './Components/Billing/NewMemberBillings';
import ManuallChequeCorrection from './Components/Cheque/ManuallChequeDetail';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/signin" replace />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<Signup />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<MainDashboard />} />
            <Route path="addmember" element={<AddMember />} />
            <Route path="addmember/:id" element={<AddMember />} />
            <Route path="memberlisting" element={<MemberListing />} />
            <Route path="addprovider" element={<AddProvider />} />
            <Route path="addtype" element={<AddType />} />
            <Route path="viewmemberdetail/:id" element={<ViewMemberPage />} />
            <Route path="billinglisting" element={<MainBillingListing />} />
            <Route path="/dashboard/billing/:id" element={<BillingListing />} />
            <Route path="/dashboard/history/:id" element={<BillingHistory />} />
            <Route path="/dashboard/process/:id" element={<ProcessCheque />} />
            <Route path="/dashboard/viewchequedetails/:id" element={<ChequeDetailsPage />} />
            <Route path="/dashboard/clients" element={<ClientList />} />
            <Route path="/dashboard/addclient" element={<AddClient />} />
            <Route path="/dashboard/addclient/:id" element={<AddClient />} />
            <Route path="/dashboard/addcheque" element={<AddCheque />} />
            <Route path="/dashboard/addcheque/:id" element={<AddCheque />} />
            <Route path="/dashboard/chequelist" element={<ChequeList />} />
            <Route path="/dashboard/checktype" element={<AddChequeType />} />
            <Route path="/dashboard/newmemberbilling/:id" element={<NewMemberBillings />} />
            <Route path="/dashboard/recheckDetail/:id" element={<ManuallChequeCorrection />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
